import fetch from 'node-fetch';
import { AuditEntry } from '../types/audit';
import { getAuthToken, getBaseApiUrl } from './helpers';

let firstTime: boolean;

export const getAudits = async (
  accountId: string,
  actorFilter: string,
  targetFilter: string,
  actionFilter: string,
  startDate: string,
  endDate: string,
  size?: number,
): Promise<AuditEntry[]> => {
  firstTime = true;
  const url = `${getBaseApiUrl()}/v1/api/archive/audit${buildFilterParam('accountId', accountId)}${buildFilterParam('actor', actorFilter)}${buildFilterParam(
    'target',
    targetFilter,
  )}${buildFilterParam('action', actionFilter)}${buildFilterParam('startDate', startDate)}${buildFilterParam('endDate', endDate)}${
    size !== undefined ? buildFilterParam('size', String(size)) : ''
  }`;
  const response = await fetch(url, {
    headers: {
      Authorization: await getAuthToken(),
    },
  });
  if (response.ok) {
    return response.json() as Promise<AuditEntry[]>;
  } else if (response.status === 404) {
    return Promise.reject('Error 404');
  } else {
    return Promise.reject('Call Failed: ' + response.status);
  }
};

const buildFilterParam = (param: string, value: string): string => {
  if (!param || !value || value === '') return '';
  const toReturn = `${firstTime ? '?' : '&'}${encodeURIComponent(param)}=${encodeURIComponent(value)}`;
  if (firstTime) firstTime = false;
  return toReturn;
};
